// extracted by mini-css-extract-plugin
export default {"container":"TableThreeFragment_container__kyZyH","header":"TableThreeFragment_header__aIWIE"};